export interface Manga {
  id: number;
  title: string;
  slug: string;
  categoryId: string;
  author: string;
  cover: string;
  latestChapter: string;
  totalChapters: number;
  status: '连载中' | '已完结';
  updateTime: string;
  releaseDay: string;
  rating: number;
  followers: number;
  tags: string[];
  brief: string;
  featured?: boolean;
  hot?: boolean;
}

export const mangas: Manga[] = [
  {
    id: 1,
    title: '星穹剑鸣录',
    slug: 'xingqiong-jianminglu',
    categoryId: 'xuanhuan',
    author: '青岚',
    cover: 'https://readdy.ai/api/search-image?query=stylized%20manga%20cover%20illustration%20of%20a%20young%20swordsman%20holding%20a%20glowing%20celestial%20sword%2C%20starry%20night%20sky%20background%2C%20warm%20orange%20and%20deep%20indigo%20palette%2C%20dynamic%20composition%2C%20clean%20graphic%20art%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=manga-cover-01&orientation=portrait',
    latestChapter: '第 152 话 · 剑出苍穹',
    totalChapters: 152,
    status: '连载中',
    updateTime: '今天 08:30',
    releaseDay: '周一',
    rating: 9.4,
    followers: 328000,
    tags: ['剑修', '玄幻', '热血'],
    brief: '少年云澈在星空遗迹中获得上古剑魂，踏上以剑问天的逆天之路。',
    featured: true,
    hot: true,
  },
  {
    id: 2,
    title: '炎狱之刃',
    slug: 'yanyu-zhiren',
    categoryId: 'rexue',
    author: '炽焰工作室',
    cover: 'https://readdy.ai/api/search-image?query=stylized%20manga%20cover%20of%20a%20fierce%20warrior%20wreathed%20in%20flames%20holding%20a%20large%20blade%2C%20embers%20and%20sparks%2C%20dark%20crimson%20and%20amber%20palette%2C%20dynamic%20action%20pose%2C%20clean%20graphic%20illustration%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=manga-cover-02&orientation=portrait',
    latestChapter: '第 98 话 · 灼热对决',
    totalChapters: 98,
    status: '连载中',
    updateTime: '今天 09:12',
    releaseDay: '周三',
    rating: 9.1,
    followers: 256000,
    tags: ['热血', '战斗', '成长'],
    brief: '被灭族的少年背负复仇之刃，在层层炼狱中磨砺出属于他的燃烧之路。',
    featured: true,
    hot: true,
  },
  {
    id: 3,
    title: '恋爱信号',
    slug: 'lianai-xinhao',
    categoryId: 'lianai',
    author: '甜甜圈',
    cover: 'https://readdy.ai/api/search-image?query=stylized%20romance%20manga%20cover%20of%20a%20shy%20high%20school%20couple%20under%20cherry%20blossom%20trees%2C%20soft%20pink%20and%20cream%20palette%2C%20gentle%20bokeh%20lighting%2C%20sweet%20atmosphere%2C%20clean%20graphic%20illustration%2C%20no%20text&width=600&height=800&seq=manga-cover-03&orientation=portrait',
    latestChapter: '第 67 话 · 心跳加速',
    totalChapters: 67,
    status: '连载中',
    updateTime: '今天 10:05',
    releaseDay: '周五',
    rating: 9.2,
    followers: 189000,
    tags: ['校园', '纯爱', '治愈'],
    brief: '性格内敛的学霸和元气少女的同桌日常，一段关于"信号"的心动故事。',
    featured: true,
  },
  {
    id: 4,
    title: '雾都谜案',
    slug: 'wudu-mian',
    categoryId: 'xuanyi',
    author: '墨鱼卷',
    cover: 'https://readdy.ai/api/search-image?query=stylized%20mystery%20manga%20cover%20of%20a%20detective%20in%20a%20trench%20coat%20walking%20in%20a%20foggy%20noir%20city%20alley%2C%20moody%20teal%20and%20charcoal%20palette%2C%20dramatic%20shadows%2C%20atmospheric%2C%20clean%20graphic%20illustration%2C%20no%20text&width=600&height=800&seq=manga-cover-04&orientation=portrait',
    latestChapter: '第 43 话 · 迷雾真相',
    totalChapters: 43,
    status: '连载中',
    updateTime: '昨天 20:40',
    releaseDay: '周六',
    rating: 8.9,
    followers: 142000,
    tags: ['悬疑', '推理', '都市'],
    brief: '雾气弥漫的都市接连发生离奇案件，年轻侦探在层层谜团中寻找真相。',
  },
  {
    id: 5,
    title: '银河远征队',
    slug: 'yinhe-yuanzhengdui',
    categoryId: 'kehuan',
    author: '轨道尽头',
    cover: 'https://readdy.ai/api/search-image?query=stylized%20sci-fi%20manga%20cover%20of%20a%20group%20of%20astronauts%20and%20a%20mecha%20in%20front%20of%20a%20colorful%20nebula%20and%20space%20station%2C%20vivid%20purple%20and%20orange%20palette%2C%20epic%20scale%2C%20clean%20graphic%20illustration%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=manga-cover-05&orientation=portrait',
    latestChapter: '第 120 话 · 深空遇袭',
    totalChapters: 120,
    status: '连载中',
    updateTime: '今天 07:50',
    releaseDay: '周二',
    rating: 9.0,
    followers: 210000,
    tags: ['科幻', '机甲', '冒险'],
    brief: '一支年轻的远征队在浩瀚银河中探索未知星球，守护人类的火种。',
    featured: true,
  },
  {
    id: 6,
    title: '沙雕室友观察日记',
    slug: 'shadiao-shiyou',
    categoryId: 'gaoxiao',
    author: '咸鱼君',
    cover: 'https://readdy.ai/api/search-image?query=fun%20comedy%20manga%20cover%20of%20a%20group%20of%20students%20making%20silly%20poses%20in%20a%20dorm%20room%2C%20bright%20cheerful%20yellow%20and%20sky%20blue%20palette%2C%20playful%20cartoon%20style%2C%20lighthearted%2C%20clean%20graphic%20illustration%2C%20no%20text&width=600&height=800&seq=manga-cover-06&orientation=portrait',
    latestChapter: '第 215 话 · 新室友驾到',
    totalChapters: 215,
    status: '连载中',
    updateTime: '昨天 18:20',
    releaseDay: '周四',
    rating: 9.3,
    followers: 305000,
    tags: ['搞笑', '校园', '日常'],
    brief: '四个性格迥异的室友住在同一屋檐下，每一天都是新的沙雕现场。',
    hot: true,
  },
  {
    id: 7,
    title: '剑与契约',
    slug: 'jianyu-qiyue',
    categoryId: 'xuanhuan',
    author: '苍梧',
    cover: 'https://readdy.ai/api/search-image?query=stylized%20fantasy%20manga%20cover%20of%20a%20knight%20and%20a%20dragon%20forming%20a%20pact%20under%20a%20giant%20sword%2C%20emerald%20green%20and%20gold%20palette%2C%20epic%20fantasy%20atmosphere%2C%20clean%20graphic%20illustration%2C%20no%20text&width=600&height=800&seq=manga-cover-07&orientation=portrait',
    latestChapter: '第 88 话 · 龙之誓约',
    totalChapters: 88,
    status: '连载中',
    updateTime: '今天 11:20',
    releaseDay: '周一',
    rating: 8.8,
    followers: 98000,
    tags: ['奇幻', '契约', '冒险'],
    brief: '落魄骑士与高傲幼龙缔结契约，共同踏上拯救王国的冒险之旅。',
  },
  {
    id: 8,
    title: '影子侦探',
    slug: 'yingzi-zhentan',
    categoryId: 'xuanyi',
    author: '夜行者',
    cover: 'https://readdy.ai/api/search-image?query=stylized%20thriller%20manga%20cover%20of%20a%20mysterious%20detective%20silhouette%20in%20a%20rainy%20city%20at%20night%2C%20neon%20reflections%2C%20dark%20blue%20and%20crimson%20palette%2C%20tense%20atmosphere%2C%20clean%20graphic%20illustration%2C%20no%20text&width=600&height=800&seq=manga-cover-08&orientation=portrait',
    latestChapter: '第 56 话 · 夜的告白',
    totalChapters: 56,
    status: '连载中',
    updateTime: '前天 22:15',
    releaseDay: '周三',
    rating: 9.0,
    followers: 121000,
    tags: ['悬疑', '都市', '犯罪'],
    brief: '只能在暗处活动的"影子侦探"，用特殊能力破解城市里的黑暗谜题。',
  },
  {
    id: 9,
    title: '春日里的告白',
    slug: 'chunrili-de-gaobai',
    categoryId: 'lianai',
    author: '小满',
    cover: 'https://readdy.ai/api/search-image?query=soft%20romance%20manga%20cover%20of%20two%20students%20sharing%20an%20umbrella%20in%20spring%20rain%20with%20flowers%20blooming%2C%20pastel%20green%20and%20pink%20palette%2C%20tender%20mood%2C%20clean%20graphic%20illustration%2C%20no%20text&width=600&height=800&seq=manga-cover-09&orientation=portrait',
    latestChapter: '第 34 话 · 花开的季节',
    totalChapters: 34,
    status: '连载中',
    updateTime: '今天 12:40',
    releaseDay: '周日',
    rating: 8.7,
    followers: 76000,
    tags: ['恋爱', '治愈', '青春'],
    brief: '在樱花纷飞的春天，一段关于勇气与告白的温柔青春物语。',
  },
  {
    id: 10,
    title: '机械之心',
    slug: 'jixie-zhixin',
    categoryId: 'kehuan',
    author: '齿轮齿轮',
    cover: 'https://readdy.ai/api/search-image?query=stylized%20cyberpunk%20manga%20cover%20of%20a%20young%20girl%20with%20a%20mechanical%20arm%20in%20a%20neon%20future%20city%2C%20bright%20cyan%20and%20magenta%20palette%2C%20futuristic%2C%20clean%20graphic%20illustration%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=manga-cover-10&orientation=portrait',
    latestChapter: '第 73 话 · 觉醒时刻',
    totalChapters: 73,
    status: '连载中',
    updateTime: '今天 06:15',
    releaseDay: '周四',
    rating: 9.2,
    followers: 178000,
    tags: ['科幻', '赛博朋克', '战斗'],
    brief: '失去记忆的少女被改造成半机械之躯，在霓虹都市中找回"心"的存在。',
    hot: true,
  },
  {
    id: 11,
    title: '超能力日常社',
    slug: 'chaonengli-rishe',
    categoryId: 'gaoxiao',
    author: '番茄酱',
    cover: 'https://readdy.ai/api/search-image?query=comedy%20manga%20cover%20of%20a%20club%20of%20students%20with%20silly%20superpowers%20misusing%20them%2C%20vibrant%20colorful%20palette%2C%20cartoon%20style%2C%20playful%20and%20energetic%2C%20clean%20graphic%20illustration%2C%20no%20text&width=600&height=800&seq=manga-cover-11&orientation=portrait',
    latestChapter: '第 89 话 · 社团危机',
    totalChapters: 89,
    status: '连载中',
    updateTime: '昨天 15:30',
    releaseDay: '周二',
    rating: 8.6,
    followers: 83000,
    tags: ['搞笑', '超能力', '校园'],
    brief: '一群拥有奇怪超能力的学生，天天用超能力干最无聊的蠢事。',
  },
  {
    id: 12,
    title: '烈焰拳圣',
    slug: 'lieyan-quansheng',
    categoryId: 'rexue',
    author: '烈风',
    cover: 'https://readdy.ai/api/search-image?query=dynamic%20martial%20arts%20manga%20cover%20of%20a%20boxer%20throwing%20a%20fiery%20punch%20in%20a%20competition%20ring%2C%20sweat%20and%20flame%20effects%2C%20orange%20and%20dark%20palette%2C%20intense%20action%2C%20clean%20graphic%20illustration%2C%20no%20text&width=600&height=800&seq=manga-cover-12&orientation=portrait',
    latestChapter: '第 130 话 · 王者之战',
    totalChapters: 130,
    status: '连载中',
    updateTime: '今天 13:05',
    releaseDay: '周六',
    rating: 9.1,
    followers: 234000,
    tags: ['热血', '格斗', '竞技'],
    brief: '被嘲笑的落魄拳手凭借永不言弃的烈焰之拳，一步步冲向格斗之巅。',
    hot: true,
  },
];

export const releaseWeek: { day: string; items: Manga[] }[] = [
  { day: '周一', items: [mangas[0], mangas[6]] },
  { day: '周二', items: [mangas[4], mangas[10]] },
  { day: '周三', items: [mangas[1], mangas[7]] },
  { day: '周四', items: [mangas[5], mangas[9]] },
  { day: '周五', items: [mangas[2]] },
  { day: '周六', items: [mangas[3], mangas[11]] },
  { day: '周日', items: [mangas[8]] },
];